<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("occupancyreport") }}</div>
      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    class="btn-clearDate"
                    @click.prevent="onDateHandler($event)"
                  >
                    ✖
                  </button>
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-validate="'required'"
                    :value="selectedDate"
                    typeable
                    @selected="onDateHandler($event)"
                  ></Datepicker>
                  <label :class="'active'">{{ $t("date") }}</label>
                </div>
              </div>
            </div> -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedCinema && selectedCinema.cine_id ? 'shift-up' : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema.cine_name"
                class="w-100"
                variant="dropdown-curve"
              >
                <div class="px-2 pb-2">
                  <input
                    v-model="searchCinema"
                    autofocus
                    class="form-control form-control-sm"
                    :placeholder="$tc('searchCinema')"
                    required
                    type="search"
                    v-on:keydown="onSearchCinema()"
                    v-on:keyup="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    cineDropDownHandler({
                      event: $event,
                      name: 'Cinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedScreen &&
                  (selectedScreen.screen_id ||
                    selectedScreen.screen_name === 'All')
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("screen", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedScreen.screen_name"
                class="w-100"
                variant="dropdown-curve"
              >
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in CineScreens"
                  :key="dropdownIndex"
                  @click="
                    cineScreenDropDownHandler({
                      event: $event,
                      name: 'Screen',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    })
                  "
                  >{{ dropdownItem.screen_name }}
                </b-dropdown-item>
                <b-dropdown-item
                  key="allscreens"
                  @click="
                    cineScreenDropDownHandler({
                      event: $event,
                      name: 'Screen',
                      selectedItem: { screen_id: null, screen_name: 'All' },
                      index: 0,
                    })
                  "
                >
                  All
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                    ✖
                  </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangedate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                    ✖
                  </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click="onFetchReport()">
              {{ $t("fetch") }} {{ $t("report") }}
            </button>
          </div>
          <div class="col-md-3 align-self-center"></div>
        </div>
      </div>

      <div class="swc-report" v-if="!isMobile">
        <div
          class="d-flex justify-content-end align-items-center"
          v-if="PdfPath"
        >
          <div>{{ $t("download") }} as:&nbsp;</div>
          <a :href="PdfPath" target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
          <a
            v-if="ExcelPath"
            :href="getCinemaBaseURL(this.selectedCinema.cine_id) + ExcelPath"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
          <!-- <img @click="ExportExcel('xlsx')" src="@/assets/img/icons/excel.svg" height="25" width="25" /> -->
        </div>
      </div>

      <!-- Table Desktop/Tablet View -->
      <div class="swc-report" v-if="!isMobile" style="margin-top: 20px">
        <div v-if="scheduleShows.length == 0">
          <table
            border="1"
            cellpadding="5"
            cellspacing="0"
            style="width: 100%; border: 1px solid black"
          >
            <thead
              style="
                font-size: 12px;
                text-align: center;
                background-color: #c4c5c6;
              "
            >
              <tr>
                <th style="width: 15%">{{ $tc("movie", 1) }}</th>
                <th style="width: 10%">{{ $t("time") }}</th>
                <th style="width: 10%">{{ $t("SeatType") }}</th>
                <th>{{ $t("admits") }}</th>
                <th>{{ $t("entered") }}</th>
                <th v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'">
                  {{ $t("autoentered") }}
                </th>
                <th>{{ $t("unpaid") }}</th>
                <th>{{ $t("Comps") }}</th>
                <th>{{ $t("available") }}</th>
                <th style="width: 9%">{{ $tc("screen", 1) }}</th>
                <th>{{ "Occ %" }}</th>
              </tr>
            </thead>
            <tbody style="font-size: 10px">
              <tr>
                <td colspan="12">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div ref="exportable_table" v-else>
          <div class="table-wrapper">
            <table
              border="1"
              cellpadding="5"
              cellspacing="0"
              style="width: 100%; border: 1px solid black"
            >
              <thead
                class="main-header"
                style="
                  font-size: 12px;
                  text-align: center;
                  background-color: #c4c5c6;
                "
              >
                <tr>
                  <th style="width: 163px !important">{{ $tc("movie", 1) }}</th>
                  <th style="width: 10%">{{ $t("time") }}</th>
                  <th style="width: 11%">{{ $t("SeatType") }}</th>
                  <th>{{ $t("admits") }}</th>
                  <th>{{ $t("entered") }}</th>
                  <th v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'">
                    {{ $t("autoentered") }}
                  </th>
                  <th>{{ $t("unpaid") }}</th>
                  <th>{{ $t("Comps") }}</th>
                  <th>{{ $t("available") }}</th>
                  <th style="width: 9%">{{ $tc("screen", 1) }}</th>
                  <th>{{ "Occ %" }}</th>
                  <th>{{ "More" }}</th>
                </tr>
              </thead>
              <tbody style="font-size: 11px">
                <tr v-for="(movies, date) in scheduleShows" :key="date">
                  <td colspan="12" class="td">
                    <table
                      border="1"
                      cellpadding="5"
                      cellspacing="0"
                      width="100%"
                    >
                      <thead class="date-header">
                        <tr style="background-color: rgb(232, 232, 232)">
                          <th colspan="12">
                            {{ moment(date).format("DD-MMM") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        v-for="(movieShows, movieIndex) in movies"
                        :key="movieIndex"
                      >
                        <tr>
                          <td
                            class="td"
                            style="
                              width: 163px !important;
                              font-weight: bold;
                              white-space: normal !important;
                            "
                          >
                            <span>
                              {{ movieShows.movie_title }} ({{
                                movieShows.mf_name
                              }})</span
                            >
                            <span class="text-muted d-block">
                              {{ $tc("language", 1) }}:
                              {{ movieShows.lang_name }}</span
                            >
                            <span class="text-muted d-block"
                              >{{ $tc("genre", 1) }}:
                              {{ movieShows.genre_name }}</span
                            >
                            <span class="text-muted d-block"
                              >Runtime:{{
                                calculateRuntime(
                                  movieShows.ss_start_show_time,
                                  movieShows.ss_end_show_time
                                )
                              }}
                            </span>
                            <span class="text-muted d-block">
                              Total:
                              <progress-bar
                                :options="options"
                                :value="
                                  (movieShows.total_admits /
                                    movieShows.total_seats) *
                                  100
                                "
                              />
                              <strong class="text-blue"
                                >{{ movieShows && movieShows.total_admits }}
                                /
                                {{ movieShows.total_seats }}</strong
                              >
                            </span>
                          </td>
                          <td colspan="10" class="td">
                            <table
                              border="1"
                              cellpadding="5"
                              cellspacing="0"
                              width="100%"
                            >
                              <tbody
                                v-for="(
                                  seat, seatIndex
                                ) in movieShows.seat_type"
                                :key="seatIndex"
                              >
                                <tr class="table_td">
                                  <td style="width: 10%; text-align: right">
                                    {{ movieShows.ss_start_show_time }} -
                                    {{ movieShows.ss_end_show_time }}
                                  </td>
                                  <td style="width: 13%">
                                    {{ seat.sst_seat_type }}
                                  </td>
                                  <td style="width: 77px; text-align: right">
                                    {{ seat.total_admits_by_SeatType }}
                                  </td>
                                  <td style="width: 83px; text-align: right">
                                    {{
                                      AUTO_ADMIT_TICKET_AFTER_SHOW == "Y"
                                        ? movieShows.entered -
                                            parseInt(
                                              movieShows.auto_entered || 0
                                            ) || 0
                                        : movieShows.entered || 0
                                    }}
                                  </td>
                                  <td
                                    v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'"
                                    style="width: 130px; text-align: right"
                                  >
                                    {{ movieShows.auto_entered || 0 }}
                                  </td>
                                  <td style="width: 78px; text-align: right">
                                    {{ movieShows.unpaid_bookings }}
                                  </td>
                                  <td style="width: 76px; text-align: right">
                                    {{ movieShows.complementory_ticket_count }}
                                  </td>
                                  <td style="width: 94px; text-align: right">
                                    {{ movieShows.seats_available }}
                                  </td>
                                  <td style="width: 10%">
                                    {{ movieShows.screen_name }}
                                  </td>
                                  <td style="width: 60px; text-align: right">
                                    {{
                                      parseFloat(
                                        (movieShows.total_admits /
                                          movieShows.total_seats) *
                                          100
                                      ).toFixed(MIN_FRACTION_DIGITS)
                                    }}%
                                  </td>
                                </tr>
                              </tbody>
                              <!-- <tr
                                  v-if="movieShows"
                                  class="bg-transparent-blue"
                                >
                                  <td colspan="2" style="font-weight: bold">
                                    Total
                                  </td>
                                  <td colspan="9" style="text-align: center">
                                    <progress-bar
                                      :options="options"
                                      :value="
                                        (movieShows.total_admits /
                                          movieShows.total_seats) *
                                        100
                                      "
                                    />
                                    <strong class="text-blue"
                                      >{{
                                        movieShows && movieShows.total_admits
                                      }}
                                      /
                                      {{ movieShows.total_seats }}</strong
                                    >
                                  </td>
                                </tr> -->
                            </table>
                          </td>
                          <td>
                            <div class="text-center">
                              <b-dropdown
                                right
                                variant="edit"
                                id="dropdown-dropup"
                                size="sm"
                                no-caret
                              >
                                <!-- <template #button-content>
                                  <span class="text-primary underline fs-10"
                                    >View</span
                                  >
                                </template> -->
                                <b-dropdown-item
                                  @click.prevent.stop="
                                    onViewSeatLayout(movieShows)
                                  "
                                  :title="'View Seat Layout'"
                                >
                                  View Seat layout
                                </b-dropdown-item>
                                <b-dropdown-item
                                  @click.prevent.stop="
                                    onViewTransactions(movieShows)
                                  "
                                  :title="'View Transactions'"
                                >
                                  View Transactions
                                </b-dropdown-item>
                              </b-dropdown>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Table Mobile View -->
      <div class="mobile-occupancy-report" v-if="isMobile">
        <div v-for="(moviesByDate, date) in scheduleShows" :key="date">
          <h6>{{ moment(date).format("DD-MMM") }}</h6>
          <article
            class="mobile-occupancy-sub-report"
            v-for="(movies, movieId) in moviesByDate"
            :key="movieId"
          >
            <div
              class="sub-report-toggle section-title section-border"
              v-b-toggle="`table-${date}-${movieId}`"
            >
              <div class="pr-2">
                <span>{{ movies.movie_title }}</span>
                <span
                  >{{ movies.ss_start_show_time }} -
                  {{ movies.ss_end_show_time }}</span
                >
                <span>{{ movies.total_admits }}/ {{ movies.total_seats }}</span>
              </div>
              <button type="button" class="btn-transparent chevron">
                <img
                  src="@/assets/img/icons/primary/chevron-down.svg"
                  height="24"
                  width="24"
                />
              </button>
            </div>
            <b-collapse :id="`table-${date}-${movieId}`">
              <table border="1">
                <tr>
                  <td colspan="1">{{ $tc("movie", 1) }}</td>
                  <td colspan="1">{{ movies.movie_title }}</td>
                </tr>
                <tr>
                  <td colspan="1">{{ $t("time") }}</td>
                  <td colspan="1">
                    {{ movies.ss_start_show_time }} -
                    {{ movies.ss_end_show_time }}
                  </td>
                </tr>
                <tr>
                  <td colspan="1">{{ $t("admits") }}</td>
                  <td colspan="1">{{ movies.total_admits }}</td>
                </tr>
                <tr v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'">
                  <td colspan="1">{{ $t("entered") }}</td>
                  <td colspan="1">
                    {{
                      movies.entered - parseInt(movies.auto_entered || 0) || 0
                    }}
                  </td>
                </tr>

                <tr v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'">
                  <td colspan="1">{{ $t("autoentered") }}</td>
                  <td colspan="1">{{ movies.auto_entered || 0 }}</td>
                </tr>

                <tr v-else>
                  <td colspan="1">{{ $t("entered") }}</td>
                  <td colspan="1">{{ movies.entered || 0 }}</td>
                </tr>
                <tr>
                  <td colspan="1">{{ $t("unpaid") }} {{ $t("booking") }}</td>
                  <td colspan="1">{{ movies.unpaid_bookings }}</td>
                </tr>
                <tr>
                  <td colspan="1">{{ $t("Comps") }}</td>
                  <td colspan="1">
                    {{ movies.complementory_ticket_count }}
                  </td>
                </tr>
                <tr>
                  <td colspan="1">{{ $t("available") }}</td>
                  <td colspan="1">{{ movies.seats_available }}</td>
                </tr>
                <tr>
                  <td colspan="1">{{ $tc("screen", 1) }}</td>
                  <td colspan="1">{{ movies.screen_name }}</td>
                </tr>
                <tr>
                  <td colspan="1">{{ "Occ %" }}</td>
                  <td colspan="1">
                    {{
                      parseFloat(
                        (movies.total_admits / movies.total_seats) * 100
                      ).toFixed(MIN_FRACTION_DIGITS)
                    }}%
                  </td>
                </tr>
              </table>
            </b-collapse>
          </article>
        </div>
      </div>
    </div>
    <ShowSeatLayoutPopup
      modalId="seatLayoutView"
      :md_id="selectedShowDetails.md_id"
      :screen_id="selectedShowDetails.screen_id"
      :ss_id="selectedShowDetails.ss_id"
      :cinema_id="selectedShowDetails.cinema_id"
      :showDetails="selectedShowDetails.showDetails"
    />

    <ScheduleWiseTransactionsPopup
      modalId="transactionView"
      :ss_id="selectedShowDetails.ss_id"
      :cinema_id="selectedShowDetails.cinema_id"
      :showDetails="selectedShowDetails.showDetails"
    />
  </div>
</template>
  
  <script>
import { mapActions, mapGetters } from "vuex";
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportService from "@/services/ReportsService";
import vue from "vue";
import PosService from "../../../services/PosService";
import { groupBy } from "lodash";
import moment from "moment";
import CinemasService from "../../../services/CinemasService";
import NoRecords from "@/components/Partials/NoRecords.vue";
import * as XLSX from "xlsx";
import ShowSeatLayoutPopup from "@/components/Partials/ShowSeatLayoutPopup.vue";
import ScheduleWiseTransactionsPopup from "@/components/Partials/ScheduleWiseTransactionsPopup.vue";
import { getCinemaBaseURL } from "@/services/Api"

export default {
  components: {
    NoRecords,
    ShowSeatLayoutPopup,
    ScheduleWiseTransactionsPopup,
  },
  data() {
    return {
      selectedShowDetails: {
        md_id: null,
        screen_id: null,
        ss_id: null,
        cinema_id: null,
        showDetails: {
          screen_name: "",
          movie_name: "",
          ss_actual_start_date: "",
          ss_start_show_time: "",
        },
      },
      FilePathArray: [],
      BASEURL,
      PdfPath: "",
      ExcelPath: "",
      DailyReportDataV2: [],
      Cinemas: [],
      isRoleID: true,
      CinemasCopy: [],
      selectedCinema: { cine_id: null },
      searchCinema: "",
      options: {
        text: {
          shadowEnable: true,
          shadowColor: "#000000",
          color: "#D3D3D3",
          fontSize: 14,
          fontFamily: "Helvetica",
          dynamicPosition: false,
          hideText: true,
        },
        progress: {
          color: "#9ACD32",
          backgroundColor: "#D3D3D3",
          inverted: false,
        },
        layout: {
          height: 20,
          width: 75,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: "line",
        },
      },
      scheduleShows: [],
      CineScreens: [],
      selectedScreen: { screen_id: null },
      selectedDate: new Date(),
      fromDate: new Date(),
      toDate: new Date(),
    };
  },
  computed: {
    ...mapGetters([
      // GET LIST ONLY
      "getPosUsersList",
      "AUTO_ADMIT_TICKET_AFTER_SHOW",
      "getPaymentTypesList",
      "getCinemasList",
      "getDailyConcessionReportList",
      // Flags
      "getDailyReportsIsCinema",
      "getDailyReportsIsExcelDownload",
      // Rendered List
      "getDailyReportList",
      "getDailyRefundList",
      // Selected Dates
      "getDailyReportToDate",
      "getDailyReportFromDate",
      // Selected Dropdowns
      "getDailyReportSelectedPaymentMode",
      "getDailyReportSelectedPosUser",
      "getDailyReportSelectedCinema",
      // FILEs
      "getDailyExcelFileName",
      // PSD
      "getDailyPDFFileName",
      // GET TOTALs
      "getGrandTotal",
      "getBoxOfficeTotal",
      "getConcessionOfficeTotal",
      "getPaymentSummary",
      "getFilmSummary",
      "getUserWiseSummary",
      "getRefundSummary",
      "getConcessionDailyReportData",
      "grandTotalForConcessionsReport",
      "getConcessionDailyExcelFileName",
      "getConcessionDailyPdfFileName",
    ]),
    isMobile() {
      return this.$store.getters.getIsMobile;
    },
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.cineDropDownHandler({
          event: null,
          name: "Cinema",
          selectedItem: CinemaObj,
          index: null,
        });
      }
    },
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.cinema_id = cinemaId;
    this.getCinemaList(cinemaId);
    //this.getOccupancyStatus({cinemaId})
  },
  mounted() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.selectedCinema.cine_name = CinemaObj.cine_name;
      this.cineDropDownHandler({
        event: null,
        name: "Cinema",
        selectedItem: CinemaObj,
        index: null,
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    this.removeDownloadedFile();
    next();
  },
  created() {
    window.addEventListener("unload", (event) => {
      this.removeDownloadedFile();
    });
  },
  beforeDestroy() {
    this.removeDownloadedFile();
  },
  methods: {
    getCinemaBaseURL,
    onViewSeatLayout(filmInfo) {
      this.selectedShowDetails = {
        md_id: filmInfo["md_id"],
        screen_id: filmInfo["screen_id"],
        ss_id: filmInfo["ss_id"],
        cinema_id: this.selectedCinema.cine_id,
        showDetails: {
          screen_name: filmInfo["screen_name"],
          movie_name: filmInfo["movie_title"],
          ss_actual_start_date: moment(filmInfo["ss_start_date"]).format(
            "YYYY-MM-DD"
          ),
          ss_start_show_time: filmInfo["ss_start_show_time"],
        },
      };
      this.$bvModal.show("seatLayoutView");
    },
    onViewTransactions(filmInfo) {
      this.selectedShowDetails = {
        md_id: filmInfo["md_id"],
        screen_id: filmInfo["screen_id"],
        ss_id: filmInfo["ss_id"],
        cinema_id: this.selectedCinema.cine_id,
        showDetails: {
          screen_name: filmInfo["screen_name"],
          movie_name: filmInfo["movie_title"],
          ss_actual_start_date: moment(filmInfo["ss_start_date"]).format(
            "YYYY-MM-DD"
          ),
          ss_start_show_time: filmInfo["ss_start_show_time"],
        },
      };
      this.$bvModal.show("transactionView");
    },
    onChangedate(e, type) {
      if (type == "from") {
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
            wb,
            fn || "DistributorCollectionReport." + (type || "xlsx")
          );
    },

    calculateRuntime(startTime, endTime) {
      const start = moment(startTime, "HH:mm");
      const end = moment(endTime, "HH:mm");
      const duration = moment.duration(end.diff(start));
      const minutes = duration.asMinutes();
      return `${minutes} minutes`;
    },

    ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchCinemasList",
      "fetchPosUsersList",
      "fetchPaymentTypesList",

      // FETCH LIST ONLY
      "fetchDailyReportListv2",
      "onDailyReportDateHandler",
      "onDailyReportDropdownHandler",
      "onDailyReportFlagHandler",
      "onFetchDailyConcessionReport",
      // ON RESET ALL
      "onResetDailyReportStoreState",
    ]),

    onSelectCinema(cinema) {
      this.$store.dispatch("selectDropdownCinema", cinema);
    },

    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },

    onFetchReport() {
      this.getOccupancyStatus();
    },

    getCinemaList: function (cine_id) {
      this.Cinemas = [];

      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    async getOccupancyStatus() {
      if (!this.selectedCinema.cine_id) {
        this.$toasted.show("Please select a cinema");
        return;
      }

      let loader = vue.$loading.show();
      if (!this.fromDate) {
        loader.hide();
        return this.$toasted.show("Select From Date");
      }

      let payload = {
        cinema_id: this.selectedCinema.cine_id,
        cinema_name: this.selectedCinema.cine_name,
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
      };

      if (this.selectedScreen.screen_id) {
        payload.screen_id = this.selectedScreen.screen_id;
      }

      try {
        let { data } = await ReportService.GetOccupancyReport(payload);

        if (data && data.status) {
          const groupedByDate = groupBy(data.Records, "ss_start_date");

          Object.keys(groupedByDate).forEach((date) => {
            groupedByDate[date].sort((a, b) => {
              return (
                new Date(a.ss_start_show_time) - new Date(b.ss_start_show_time)
              );
            });
          });

          const sortedDates = Object.keys(groupedByDate).sort((a, b) => {
            return new Date(a) - new Date(b);
          });

          const sortedGroupedByDate = {};
          sortedDates.forEach((date) => {
            sortedGroupedByDate[date] = groupedByDate[date];
          });

          this.scheduleShows = sortedGroupedByDate;

          this.PdfPath = data.PdfPath;
          if (data.ExcelPath) {
            this.ExcelPath = data.ExcelPath;
            this.FilePathArray.push(data.ExcelPath);
          }
        } else {
          this.scheduleShows = [];
          vue.toasted.show(data.message || "Please try later");
        }
      } catch (e) {
        vue.toasted.show(e.message || "Please try later");
      } finally {
        loader.hide();
      }
    },
    removeDownloadedFile() {
      let payload = {
        fileArray: this.FilePathArray,
      };
      MasterService.RemoveDownloadedFile(payload)
        .then((response) => {
          const { data } = response;
        })
        .catch((error) => {
          console.log("error :", error);
        });
    },
    async cineDropDownHandler({ event, name, selectedItem, index }) {
      this.selectedScreen = { screen_id: null };
      this.selectedCinema = selectedItem;

      let loader = vue.$loading.show();
      let { data: ScreenData } = await CinemasService.GetActiveScreenByCinema({
        tableName: "screens",
        activekey: "screen_is_active",
        conditionColName: "cinema_id",
        conditionId: this.selectedCinema.cine_id,
        limit: 100,
        currentPage: 1,
        searchValue: "",
        searchKey: "screen_name",
        columnName: "",
        orderBy: "screen_id",
      }).catch((e) => {
        vue.toasted.show(e.message || "Please try later");
      }).finally(() => {
         loader.hide();
      });
      if (ScreenData && ScreenData.status) {
        ScreenData.Records = ScreenData.Records.filter(
          (x) => x.screen_layout_active && x.screen_is_active
        ).sort((a, b) => a.screen_id - b.screen_id);

        this.CineScreens = ScreenData.Records || [];
      } else {
        vue.toasted.show(data.message || "Please try later");
      }
    },
    onDateHandler(d) {
      if (!(d instanceof Date && !isNaN(d))) d = new Date();

      this.selectedDate = new Date(d);
    },
    cineScreenDropDownHandler({ event, name, selectedItem, index }) {
      this.selectedScreen = selectedItem;
    },
  },
};
</script>
  
  <style>
.border-bottom-black {
  border-bottom: 1px solid #787878 !important;
}

.mobile-occupancy-report table {
  width: 100%;
}

.mobile-occupancy-report * {
  border-color: #eaeaed;
}

.mobile-occupancy-report .mobile-occupancy-sub-report {
  margin: 0 -15px 20px;
}

.mobile-occupancy-report .mobile-occupancy-sub-report td {
  padding: 10px;
}

.mobile-occupancy-report .mobile-occupancy-sub-report tr > td:first-child {
  font-weight: bold;
  background-color: #f5f5f7;
}

.mobile-occupancy-report .mobile-occupancy-sub-report .sub-report-toggle {
  padding: 10px 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobile-occupancy-report
  .mobile-occupancy-sub-report
  .sub-report-toggle
  span:not(:last-child)::after {
  content: "|";
  padding: 0 4px;
}

.td {
  padding: 6px;
}
.table_td td {
  padding: 6px;
}

.bg-transparent-blue td {
  padding: 6px;
}

.table tr td.td {
  width: 163px !important;
  white-space: normal !important;
  font-weight: bold;
}

/* .table-wrapper {
  max-height: 600px;
  overflow-y: auto;
} */

/* .table-wrapper thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #c4c5c6;
} */

/* .table-wrapper th,
.table-wrapper td {
  text-align: center;
  padding: 8px;
} */

.table-wrapper {
  position: relative;
  overflow: auto;
  max-height: 400px;
}

.main-header {
  position: sticky;
  top: 0;
  z-index: 2;
}

/* .table-wrapper table {
  border: 1px solid black !important;
} */

/* .table-wrapper th, .table-wrapper td {
  border: 1px solid black !important;
}

 th {
  border: 1px solid black !important;
} */

/* .date-header {
  position: sticky !important;
  top: 30px !important;
  z-index: 1 !important;
} */
</style>
  


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/occupancyReports.vue